import { applySnapshot, getSnapshot, types } from 'mobx-state-tree'
import { fromPromise } from 'mobx-utils'
import { apiV1 } from '../../utils'
import { when } from 'mobx'

// Модель одного свойства конфигурации приложения (ключ/значение)
const ApplicationConfigModel = types.model('ApplicationConfigModel', {
  propertyName: types.string,
  propertyValue: types.string,
})

const VERSION_HEADER = { 'x-version': '1.0' }

const AppConfigStore = types
  .model('AppConfigStore')
  .props({
    _data: types.optional(types.array(ApplicationConfigModel), []),
    _isPending: types.optional(types.boolean, false),
  })
  .actions(self => {
    const API_URL = '/appconfig'

    const setAppConfigList = list => {
      applySnapshot(self._data, list)
    }

    // GET /api/appconfig/{propertyName} — получить одно свойство по имени
    const getAppConfigProperty = propertyName => {
      const request = fromPromise(apiV1.get(`${API_URL}/${propertyName}`, { headers: VERSION_HEADER }))

      when(() => {
        request.case({
          fulfilled: () => true,
          rejected: () => true,
        })
      })

      return request
    }

    // GET /api/appconfig/list — получить список всех свойств
    const getAppConfigList = () => {
      const request = fromPromise(apiV1.get(`${API_URL}/list`, { headers: VERSION_HEADER }))

      when(() => {
        request.case({
          fulfilled: response => {
            setAppConfigList(response.data)
            return true
          },
          rejected: () => true,
        })
      })

      return request
    }
    // POST /api/appconfig — установить значение свойства
    const setAppConfigProperty = (propertyName, propertyValue) => {
      const request = fromPromise(apiV1.post(API_URL, { propertyName, propertyValue }, { headers: VERSION_HEADER }))
      return request
    }

    return {
      setAppConfigList,
      getAppConfigProperty,
      getAppConfigList,
      setAppConfigProperty,
    }
  })
  .views(self => ({
    get appConfigList() {
      return getSnapshot(self._data)
    },
    get isPending() {
      return self._isPending
    },
  }))

export default AppConfigStore
